import { times, omit, cloneDeep } from 'lodash';
import { createSpeakingTaskType } from '../../createTaskType';
import { createSpeakingDifferenceItem } from "@dyl/task-types/sharedLogic/speakingItemCreators";
import SpeakingGenericEditor from "@dyl/task-types/sharedLogic/SpeakingGenericEditor";
import withProps from "@dyl/utils/withProps";

export default createSpeakingTaskType({
    id: 'spot_the_difference',
    label: 'Spot The Difference',
    skill: 'speaking',
    v2: true,
    hasRubric: false,

    editor: withProps(SpeakingGenericEditor, { disableTargets: true, includeContextAudioField: true }),
    createItemsTemplate: () => times(4, createSpeakingDifferenceItem),

    convertToUploadFormat: (task, { isNew }) => {
        task = cloneDeep(task);
        task.items = task.items.map(item => {
            item.backups = item?.backups?.map(backup => omit(backup, 'item_id'));
            item.answers = item?.answers?.map(a => {
                if (a?.image_id === '')
                    delete a.image_id;
                if (!a?.coordinates?.top && !a?.coordinates?.left)
                    delete a.coordinates;
                return a;
            });
            return item;
        })
        return task;
    },

    hasEndAudio: true,
    backgroundImages: {
        count: 1,
        configs: [
            {
                label: 'Context Image'
            }]
    }
});